import AuthCheck from './AuthCheck';

export default AuthCheck;
